export default {
  totalPages: state => {
    return Math.ceil(state.placesCount / state.limit)
  },
  currentPage: state => {
    return Math.ceil(state.skip / state.limit + 1)
  }
}
